module.exports = __webpack_public_path__ + "img/xuzhou_s.49f4311.png";